import { render, staticRenderFns } from "./Factura.vue?vue&type=template&id=67480e4c&scoped=true&"
import script from "./Factura.vue?vue&type=script&lang=js&"
export * from "./Factura.vue?vue&type=script&lang=js&"
import style0 from "./Factura.vue?vue&type=style&index=0&id=67480e4c&lang=scss&scoped=true&"
import style1 from "./Factura.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./Factura.vue?vue&type=style&index=2&id=67480e4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67480e4c",
  null
  
)

export default component.exports